import React, { useState, useEffect, useCallback } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Particles from 'react-tsparticles';
import { loadFull } from 'tsparticles';
import './App.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, EffectCoverflow } from 'swiper/modules';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import 'swiper/css';

// ===================== MODAL DE APPS CORPORATIVAS (AHORA MODAL DE SERVICIOS) =====================
const AppGridModal = ({ isOpen, onClose }) => {
  const techServices = [
    { id: 1, name: 'Diseño Web', desc: 'Sitios web responsivos y modernos', iconPath: "M4 4h16v16H4V4zm2 2v12h12V6H6zm2 2h8v2H8V8zm0 4h8v2H8v-2zm0 4h5v2H8v-2z", color: '#3A6EA5' },
    { id: 2, name: 'Apps Móviles', desc: 'iOS, Android y multiplataforma', iconPath: "M7 2h10v20H7V2zm2 2v14h6V4H9zm2 2h2v2h-2V6zm1 12a1 1 0 100 2 1 1 0 000-2z", color: '#3A6EA5' },
    { id: 3, name: 'Landing Pages', desc: 'Alta conversión y performance', iconPath: "M3 3h18v18H3V3zm2 2v14h14V5H5zm2 2h10v2H7V7zm0 4h10v2H7v-2zm0 4h6v2H7v-2z", color: '#3A6EA5' },
    { id: 4, name: 'Sistemas Web', desc: 'Plataformas escalables', iconPath: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15h-2v-2h2v2zm0-4h-2V7h2v6z", color: '#3A6EA5' },
    { id: 5, name: 'SaaS', desc: 'Software como Servicio', iconPath: "M21 12c0 4.97-4.03 9-9 9s-9-4.03-9-9 4.03-9 9-9 9 4.03 9 9zm-9-7c-3.86 0-7 3.14-7 7s3.14 7 7 7 7-3.14 7-7-3.14-7-7-7zm0 2v5l4 2-1 2-5-3V7h2z", color: '#3A6EA5' },
    { id: 6, name: 'Software Restaurantes', desc: 'Gestión integral', iconPath: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 4c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm0 13c-2.33 0-4.31-1.46-5.11-3.5h10.22c-.8 2.04-2.78 3.5-5.11 3.5z", color: '#3A6EA5' },
    { id: 7, name: 'Software Almacenes', desc: 'Control de inventario', iconPath: "M20 8h-2V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h2v2c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM4 6h12v2H4V6zm2 12v-2h10v2H6zm14-2h-2V10h2v6z", color: '#3A6EA5' },
    { id: 8, name: 'Software Logística', desc: 'Optimización de rutas', iconPath: "M20 8h-2.81c-.45-.78-1.07-1.45-1.82-1.96L17 4.41 15.59 3l-2.17 2.17C12.96 5.06 12.49 5 12 5s-.96.06-1.41.17L8.41 3 7 4.41l1.62 1.63C7.88 6.55 7.26 7.22 6.81 8H4v2h2.09c-.05.33-.09.66-.09 1v1H4v2h2v1c0 .34.04.67.09 1H4v2h2.81c1.79 2.59 5.01 4 8.19 4s6.4-1.41 8.19-4H20v-2h-2.09c.05-.33.09-.66.09-1v-1h2v-2h-2v-1c0-.34-.04-.67-.09-1H20V8z", color: '#3A6EA5' },
    { id: 9, name: 'Software Transporte', desc: 'Gestión de flotas', iconPath: "M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z", color: '#3A6EA5' },
    { id: 10, name: 'Sistemas Agrícolas', desc: 'Agricultura de precisión', iconPath: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 4c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm0 13c-2.33 0-4.31-1.46-5.11-3.5h10.22c-.8 2.04-2.78 3.5-5.11 3.5z", color: '#3A6EA5' },
  ];

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div 
          className="corporate-modal-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
        >
          <motion.div 
            className="corporate-dashboard"
            initial={{ scale: 0.7, rotateY: -45, opacity: 0, y: 50 }}
            animate={{ scale: 1, rotateY: 0, opacity: 1, y: 0 }}
            exit={{ scale: 0.5, opacity: 0 }}
            transition={{ type: "spring", damping: 20, stiffness: 80 }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="dashboard-header">
              <h2>Catálogo de Servicios Tech</h2>
              <p>Soluciones de software a la medida</p>
            </div>

            <div className="corporate-grid">
              {techServices.map((app) => (
                <motion.div 
                  key={app.id}
                  className="corp-app-card"
                  whileHover={{ y: -10, backgroundColor: "rgba(50,50,50,0.9)" }}
                  whileTap={{ scale: 0.95 }}
                >
                  <div className="corp-icon-wrapper" style={{ background: `linear-gradient(135deg, ${app.color}, #1E1E1E)` }}>
                    <svg viewBox="0 0 24 24" fill="white"><path d={app.iconPath}/></svg>
                  </div>
                  <div className="corp-app-info">
                    <span className="corp-app-title">{app.name}</span>
                    <span className="corp-app-desc">{app.desc}</span>
                  </div>
                </motion.div>
              ))}
            </div>

            <button className="corp-close-trigger" onClick={onClose}>
              Cerrar Catálogo
            </button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

// ===================== CONFIGURACIÓN DE PARTÍCULAS (GRIS) =====================
// ===================== CONFIGURACIÓN DE PARTÍCULAS (GRIS) =====================
// ===================== CONFIGURACIÓN DE PARTÍCULAS (GRIS) - VERSIÓN ALTERNATIVA =====================
const ParticlesComponent = ({ id, className }) => {
  const particlesInit = useCallback(async (engine) => {
    // Inicialización simple sin loadFull
    console.log("Particles engine initialized");
  }, []);

  const particlesOptions = {
    fpsLimit: 60,
    background: {
      color: {
        value: "transparent",
      },
    },
    particles: {
      color: {
        value: "#4A4A4A",
      },
      links: {
        color: "#4A4A4A",
        distance: 150,
        enable: true,
        opacity: 0.2,
        width: 1,
      },
      move: {
        direction: "none",
        enable: true,
        outModes: {
          default: "bounce",
        },
        random: true,
        speed: 1,
        straight: false,
      },
      number: {
        density: {
          enable: true,
          area: 800,
        },
        value: 40,
      },
      opacity: {
        value: 0.3,
        random: true,
      },
      shape: {
        type: "circle",
      },
      size: {
        value: { min: 1, max: 3 },
        random: true,
      },
    },
    detectRetina: true,
  };

  return (
    <Particles
      id={id}
      className={className}
      init={particlesInit}
      options={particlesOptions}
    />
  );
};
// ===================== PANTALLA DE CARGA =====================
const LoadingScreen = ({ onComplete }) => {
  const [isAnimating, setIsAnimating] = useState(true);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress(prev => {
        if (prev >= 100) {
          clearInterval(interval);
          return 100;
        }
        return prev + 1;
      });
    }, 20);

    setTimeout(() => {
      setIsAnimating(false);
      setTimeout(onComplete, 1000);
    }, 2500);

    return () => clearInterval(interval);
  }, [onComplete]);

  return (
    <motion.div 
      className="loading-screen"
      initial={{ opacity: 1 }}
      animate={{ opacity: isAnimating ? 1 : 0 }}
      transition={{ duration: 1 }}
    >
      <motion.div 
        className="shutter-top"
        initial={{ y: 0 }}
        animate={{ y: isAnimating ? 0 : "-100%" }}
        transition={{ duration: 1, ease: [0.6, 0.05, 0.01, 0.9] }}
      />
      
      <motion.div 
        className="shutter-bottom"
        initial={{ y: 0 }}
        animate={{ y: isAnimating ? 0 : "100%" }}
        transition={{ duration: 1, ease: [0.6, 0.05, 0.01, 0.9] }}
      />

      <motion.div 
        className="door-left"
        initial={{ x: 0 }}
        animate={{ x: isAnimating ? 0 : "-100%" }}
        transition={{ duration: 1, delay: 0.2, ease: [0.6, 0.05, 0.01, 0.9] }}
      >
        <div className="door-pattern"></div>
      </motion.div>

      <motion.div 
        className="door-right"
        initial={{ x: 0 }}
        animate={{ x: isAnimating ? 0 : "100%" }}
        transition={{ duration: 1, delay: 0.2, ease: [0.6, 0.05, 0.01, 0.9] }}
      >
        <div className="door-pattern"></div>
      </motion.div>

      <motion.div 
        className="loading-content"
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <motion.div 
          className="loading-logo-container"
          animate={{ 
            y: [0, -15, 0],
            rotateY: [0, 360]
          }}
          transition={{ 
            y: { duration: 2, repeat: Infinity },
            rotateY: { duration: 3, repeat: Infinity }
          }}
        >
          <svg width="140" height="140" viewBox="0 0 100 100">
            <defs>
              <linearGradient id="loadingGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#2D2D2D" />
                <stop offset="100%" stopColor="#4A4A4A" />
              </linearGradient>
            </defs>
            <foreignObject x="20" y="20" width="60" height="60">
              <div style={{ 
                width: '100%', 
                height: '100%', 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center' 
              }}>
                <img 
                  src="/assets/Images/logotech.png" 
                  alt="Logo"
                  style={{ 
                    maxWidth: '100%', 
                    maxHeight: '100%', 
                    objectFit: 'contain' 
                  }} 
                />
              </div>
            </foreignObject>
            
            {[0, 60, 120, 180, 240, 300].map((angle, i) => (
              <circle
                key={i}
                cx={50 + 35 * Math.cos(angle * Math.PI / 180)}
                cy={50 + 35 * Math.sin(angle * Math.PI / 180)}
                r="3"
                fill="#4A4A4A"
              >
                <animate 
                  attributeName="r" 
                  values="2;4;2" 
                  dur="2s" 
                  repeatCount="indefinite" 
                  begin={i * 0.3}
                />
                <animate 
                  attributeName="opacity" 
                  values="0.5;1;0.5" 
                  dur="2s" 
                  repeatCount="indefinite" 
                  begin={i * 0.3}
                />
              </circle>
            ))}
          </svg>
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
        >
          {'NAVESOLUTIONS'.split('').map((char, index) => (
            <motion.span
              key={index}
              animate={{ 
                color: ['#4A4A4A', '#6A6A6A', '#8A8A8A', '#4A4A4A']
              }}
              transition={{ 
                duration: 3, 
                repeat: Infinity,
                delay: index * 0.1
              }}
              style={{ display: 'inline-block' }}
            >
              {char}
            </motion.span>
          ))}
        </motion.h1>

        <div className="progress-container">
          <motion.div 
            className="progress-bar-custom"
            initial={{ width: 0 }}
            animate={{ width: `${progress}%` }}
            transition={{ duration: 0.1 }}
            style={{ backgroundColor: '#4A4A4A' }}
          >
            <motion.div 
              className="progress-glow"
              animate={{ x: ['-100%', '200%'] }}
              transition={{ duration: 1.5, repeat: Infinity }}
            />
          </motion.div>
          <span className="progress-text">{progress}%</span>
        </div>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
        >
          Innovación que transforma negocios
        </motion.p>
      </motion.div>
    </motion.div>
  );
};

// ===================== NAVBAR =====================
const Navbar = ({ scrolled, setCurrentPage, currentPage }) => {
  const menuItems = [
    { id: 'inicio', label: 'INICIO' },
    { id: 'servicios', label: 'SERVICIOS' },
    { id: 'productos', label: 'PRODUCTOS' },
    { id: 'demo', label: 'DEMOS' },
    { id: 'contacto', label: 'CONTACTO' }
  ];
  const [isAppGridOpen, setIsAppGridOpen] = useState(false);
  
  return (
    <header className={`header-corporate ${scrolled ? 'is-scrolled' : ''}`}>
      <div className="top-bar-corporate" style={{ backgroundColor: '#1A1A1A' }}>
        <div className="container-header">
          <div className="top-contact">
            <span>✉ info@navesolution.com</span>
            <span>📍 Av. Tecnológico 123, Miami , USA.</span>
          </div>
          <div className="top-social-header">
            Síguenos — <span className="social-icons">f t ln</span>
          </div>
        </div>
      </div>

      <nav className="main-nav-diagonal">
        <div className="nav-wrapper">
          <div 
            className="logo-diagonal-bg" 
            onClick={() => setCurrentPage('inicio')} 
            style={{ cursor: 'pointer', backgroundColor: '#2D2D2D' }}
          >
            <div className="logo-content">
              <img 
                src="/assets/Images/alien2.png" 
                alt="Nave Solutions" 
                className="logo-image"
                style={{ 
                  height: '100px', 
                  width: 'auto',
                  display: 'block'
                }}
              />
            </div>
          </div>

          <div className="menu-content">
            <ul className="nav-menu-list">
              {menuItems.map((item) => (
                <li key={item.id}>
                  <a 
                    href={`#${item.id}`}
                    className={currentPage === item.id ? 'active' : ''}
                    onClick={(e) => {
                      e.preventDefault();
                      setCurrentPage(item.id);
                    }}
                  >
                    {item.label} {item.id !== 'contacto' ? '▾' : ''}
                  </a>
                </li>
              ))}
            </ul>
         
            <AppGridModal 
              isOpen={isAppGridOpen} 
              onClose={() => setIsAppGridOpen(false)} 
            />
            <div className="nav-right-actions">
              <button className="btn-icon-pure" aria-label="Buscar">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                  <circle cx="11" cy="11" r="8"></circle>
                  <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                </svg>
              </button>

              <button className="btn-icon-pure" onClick={() => setIsAppGridOpen(true)}>
                <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
                  <rect x="3" y="3" width="4" height="4" rx="1" />
                  <rect x="10" y="3" width="4" height="4" rx="1" />
                  <rect x="17" y="3" width="4" height="4" rx="1" />
                  <rect x="3" y="10" width="4" height="4" rx="1" />
                  <rect x="10" y="10" width="4" height="4" rx="1" />
                  <rect x="17" y="10" width="4" height="4" rx="1" />
                  <rect x="3" y="17" width="4" height="4" rx="1" />
                  <rect x="10" y="17" width="4" height="4" rx="1" />
                  <rect x="17" y="17" width="4" height="4" rx="1" />
                </svg>
              </button>
              <button 
                className="cta-corporate-btn"
                onClick={() => setCurrentPage('contacto')}
                style={{ backgroundColor: '#3A6EA5' }}
              >
                COTIZAR
              </button>
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
};

// ===================== HERO =====================
const Hero = () => {
  const [videoLoaded, setVideoLoaded] = useState(false);

  return (
    <section className="hero-slaze">
      <div className="hero-main-container">
        <div className="hero-text-side" style={{ backgroundColor: '#F5F5F5' }}>
          <motion.div 
            className="hero-content-wrapper"
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
          >
            <span className="hero-subtitle" style={{ color: '#3A6EA5' }}>| SOLUCIONES DIGITALES</span>
            <h1 className="hero-title">
              Desarrollo de Software <br />
              <span className="hero-title-bold" style={{ color: '#2D2D2D' }}>A Medida</span>
            </h1>
            <p className="hero-description">
              Creamos sistemas web, apps móviles y software empresarial <br />
              que impulsan la transformación digital de tu negocio.
            </p>
            
            <motion.button 
              className="btn-discover"
              whileHover={{ scale: 1.05, backgroundColor: '#2D5A8C' }}
              whileTap={{ scale: 0.95 }}
              style={{ backgroundColor: '#3A6EA5' }}
            >
              DESCUBRE NUESTROS SERVICIOS
            </motion.button>
          </motion.div>
        </div>

        <div className="hero-video-side">
          <div className="video-container-clip">
             <motion.video 
                autoPlay 
                loop 
                muted 
                playsInline
                className="hero-video-render"
                onLoadedData={() => setVideoLoaded(true)}
                initial={{ opacity: 0 }}
                animate={{ opacity: videoLoaded ? 1 : 0 }}
                transition={{ duration: 1 }}
              >
                <source src="/assets/Videos/fut1.mp4" type="video/mp4" />
              </motion.video>
              <div className="video-overlay-soft"></div>
          </div>
          
          <div className="hero-navigation-arrows">
            <button className="nav-arrow prev">←</button>
            <button className="nav-arrow next active">→</button>
          </div>
        </div>
      </div>

      <div className="hero-stats-footer">
        <div className="stats-green-box" style={{ backgroundColor: '#2D2D2D' }}>
          <div className="stat-unit">
            <span className="stat-num">500+</span>
            <span className="stat-txt">PROYECTOS ENTREGADOS</span>
          </div>
          <div className="stat-unit">
            <span className="stat-num">98%</span>
            <span className="stat-txt">SATISFACCIÓN CLIENTE</span>
          </div>
        </div>
        <div className="stats-dark-box"></div>
      </div>
    </section>
  );
};

// ===================== SOBRE NOSOTROS =====================
const AboutSection = () => {
  const [isOpen, setIsOpen] = useState(false);

  const skills = [
    { label: 'Desarrollo Web', percentage: 95 },
    { label: 'Apps Móviles', percentage: 88 },
    { label: 'Software Empresarial', percentage: 92 },
  ];

  return (
    <section className="about-section">
      <div className="container-about">
        <div className="about-images-wrapper">
          <div className="main-img-container">
            <img src="/assets/Images/team-dev.jpg" alt="Equipo de desarrollo" className="img-worker" />
            
            <motion.div 
              className="percentage-circle-card"
              initial={{ scale: 0 }}
              whileInView={{ scale: 1 }}
              viewport={{ once: true }}
            >
              <div className="circle-progress">
                <svg viewBox="0 0 36 36" className="circular-chart">
                  <path className="circle-bg" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
                  <motion.path
                    className="circle"
                    strokeDasharray="95, 100"
                    d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                    initial={{ pathLength: 0 }}
                    whileInView={{ pathLength: 0.95 }}
                    transition={{ duration: 2, ease: "easeOut" }}
                    style={{ stroke: '#3A6EA5' }}
                  />
                  <text x="18" y="20.35" className="percentage">95%</text>
                </svg>
              </div>
              <div className="circle-info">
                <span>Proyectos</span>
                <strong>Retención de Clientes</strong>
              </div>
            </motion.div>
          </div>
          
          <img src="/assets/Images/office-tech.jpg" alt="Oficina tech" className="img-panels" />
          <div className="dots-pattern"></div>
        </div>

        <div className="about-content">
          <span className="subtitle-green" style={{ color: '#3A6EA5' }}>| QUIÉNES SOMOS</span>
          <h2 className="about-title">Expertos en Transformación Digital</h2>
          <p className="about-desc">
            Somos una agencia de tecnología con más de 10 años de experiencia desarrollando soluciones 
            de software a medida. Nuestro equipo de ingenieros y diseñadores crea productos digitales 
            que resuelven problemas reales y generan valor para nuestros clientes.
          </p>

          <div className="skills-container">
            {skills.map((skill, index) => (
              <div className="skill-item" key={index}>
                <div className="skill-info">
                  <span>{skill.label}</span>
                  <span>{skill.percentage}%</span>
                </div>
                <div className="progress-bar-bg">
                  <motion.div 
                    className="progress-bar-fill"
                    initial={{ width: 0 }}
                    whileInView={{ width: `${skill.percentage}%` }}
                    transition={{ duration: 1.5, delay: index * 0.2 }}
                    viewport={{ once: false }}
                    style={{ backgroundColor: '#3A6EA5' }}
                  />
                </div>
              </div>
            ))}
          </div>

          <div className="about-actions">
            <button className="btn-unlock" style={{ backgroundColor: '#2D2D2D' }}>CONOCE NUESTRO EQUIPO</button>
            
            <div className="video-trigger" onClick={() => setIsOpen(true)}>
              <div className="play-btn-circle" style={{ borderColor: '#3A6EA5' }}>
                <span className="play-icon">▶</span>
              </div>
              <span>Ver Video</span>
            </div>
          </div>
        </div>
      </div>

      {isOpen && (
        <div className="video-modal-overlay" onClick={() => setIsOpen(false)}>
          <div className="video-modal-content" onClick={e => e.stopPropagation()}>
            <button className="close-modal" onClick={() => setIsOpen(false)}>×</button>
            <iframe 
              width="100%" 
              height="500" 
              src="https://www.youtube.com/embed/STBxYIjN7X0?autoplay=1" 
              title="Video Nave Solutions" 
              frameBorder="0" 
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
              allowFullScreen
            ></iframe>
          </div>
        </div>
      )}
    </section>
  );
};

// ===================== GALERÍA DE PROYECTOS =====================
const ProjectGallery = () => {
  const projects = [
    { id: 1, title: 'E-commerce Platform', category: 'Desarrollo Web', img: '/assets/Images/ecommerce.jpg' },
    { id: 2, title: 'Delivery App', category: 'Apps Móviles', img: '/assets/Images/delivery-app.jpg' },
    { id: 3, title: 'ERP Restaurant', category: 'Software Administrativo', img: '/assets/Images/erp.jpg' },
    { id: 4, title: 'SaaS Analytics', category: 'Plataforma SaaS', img: '/assets/Images/saas.jpg' },
    { id: 5, title: 'Logistics System', category: 'Software Logística', img: '/assets/Images/logistics.jpg' },
  ];

  return (
    <section className="gallery-section">
      <div className="gallery-header">
        <div className="header-left">
          <span className="subtitle-green" style={{ color: '#3A6EA5' }}>| PORTAFOLIO</span>
          <h2 className="gallery-title">Proyectos Recientes</h2>
        </div>
        <button className="btn-view-all" style={{ borderColor: '#3A6EA5', color: '#3A6EA5' }}>VER TODOS LOS PROYECTOS</button>
      </div>

      <Swiper
        modules={[Autoplay, Pagination]}
        spaceBetween={30}
        slidesPerView={1}
        loop={true}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        breakpoints={{
          640: { slidesPerView: 2 },
          1024: { slidesPerView: 3.5 },
        }}
        className="projects-swiper"
      >
        {projects.map((project) => (
          <SwiperSlide key={project.id}>
            <div className="project-card">
              <img src={project.img} alt={project.title} className="project-img" />
              
              <div className="project-info-overlay">
                <div className="info-card">
                  <span className="info-category" style={{ color: '#3A6EA5' }}>─ {project.category}</span>
                  <h3 className="info-title">{project.title}</h3>
                  <motion.button 
                    className="info-btn-arrow"
                    whileHover={{ scale: 1.1 }}
                    style={{ color: '#3A6EA5' }}
                  >
                    ↗
                  </motion.button>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

// ===================== SECCIÓN DE ESTADÍSTICAS =====================
const StatsSection = () => {
  const stats = [
    { value: 0, label: 'AÑOS DE EXPERIENCIA', suffix: '+', icon: 'YEARS' },
    { value: 0, label: 'CLIENTES SATISFECHOS', suffix: '+', icon: 'TEAM' },
    { value: 0, label: 'PROYECTOS ENTREGADOS', suffix: '+', icon: 'PROJ' },
    { value: 0, label: 'PAÍSES', suffix: '', icon: 'GLOBE' }
  ];

  const [counts, setCounts] = useState(stats.map(() => 0));

  useEffect(() => {
    const intervals = stats.map((stat, index) => {
      const target = stat.value;
      return setInterval(() => {
        setCounts(prev => {
          const newCounts = [...prev];
          if (newCounts[index] < target) {
            newCounts[index] = Math.min(newCounts[index] + Math.ceil(target / 45), target);
          }
          return newCounts;
        });
      }, 40);
    });
    return () => intervals.forEach(clearInterval);
  }, []);

  return (
    <section className="corporate-stats-centered">
      <ParticlesComponent id="stats-particles" className="stats-particles" />
      <div className="stats-container">
        <div className="stats-main-grid">
          {stats.map((stat, index) => (
            <motion.div
              key={index}
              className="stat-card-corporate"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: false }}
              transition={{ delay: index * 0.1 }}
            >
              <div className="icon-wrapper-corp">
                <div className="inner-circle-icon" style={{ backgroundColor: '#3A6EA5' }}>
                  {stat.icon === 'YEARS' && '⏱️'}
                  {stat.icon === 'TEAM' && '👥'}
                  {stat.icon === 'PROJ' && '🏗️'}
                  {stat.icon === 'GLOBE' && '🌐'}
                </div>
              </div>

              <div className="stat-text-center">
                <h3 className="stat-value-big">
                  {counts[index].toLocaleString()}{stat.suffix}
                </h3>
                <p className="stat-description-corp">{stat.label}</p>
              </div>
              
              <div className="stat-load-bar-container">
                <motion.div 
                  className="stat-load-bar-fill"
                  initial={{ width: 0 }}
                  whileInView={{ width: '100%' }}
                  viewport={{ once: false }}
                  transition={{ duration: 1.5, ease: "easeOut" }}
                  style={{ backgroundColor: '#3A6EA5' }}
                />
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

// ===================== EQUIPO =====================
const TeamCarousel = () => {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsReady(true);
    }, 4000);
    return () => clearTimeout(timer);
  }, []);

  const staff = [
    { id: 1, name: "José Luis Bruzco", role: "CEO & Fundador", area: "Dirección", img: "https://firebasestorage.googleapis.com/v0/b/gamerven-79643.firebasestorage.app/o/IMG-20260322-WA0005.jpg?alt=media&token=e92fef9b-7905-4c18-9cd7-a3ee8eed78ae" },
    { id: 2, name: "Laura Fernández", role: "Directora de Desarrollo", area: "Ingeniería", img: "https://firebasestorage.googleapis.com/v0/b/gamerven-79643.firebasestorage.app/o/Yuraiza%20Garc%C3%ADa.jpg?alt=media&token=3dbd1e70-1562-42cc-8fd4-6683f9bb2810" },
    { id: 3, name: "Miguel Ángel", role: "Lead Developer", area: "Backend", img: "/assets/Images/lead-dev.jpg" },
    { id: 4, name: "Sofía Ramírez", role: "UX/UI Designer", area: "Diseño", img: "https://firebasestorage.googleapis.com/v0/b/gamerven-79643.firebasestorage.app/o/Alejandra%20Coa.jpg?alt=media&token=b910095d-f136-46ba-9ca3-961ff9e08aeb" },
    { id: 5, name: "Gabriel Bruzco", role: "Dev Software", area: "Software", img: "https://firebasestorage.googleapis.com/v0/b/gamerven-79643.firebasestorage.app/o/IMG-20260312-WA0027.jpg?alt=media&token=2e927207-e9fc-421e-be56-76f2229dd006" }
  ];

  return (
    <div className="section-staff-horizontal" style={{ width: '100%', overflow: 'hidden', padding: '100px 0' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto 50px', padding: '0 20px', textAlign: 'left' }}>
        <motion.div
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
        >
          <span style={{ color: '#3A6EA5', fontWeight: '800', letterSpacing: '3px', fontSize: '14px' }}>
            TALENTO TECNOLÓGICO
          </span>
          <h2 style={{ fontSize: '3rem', fontWeight: '900', color: '#1a1a1a', margin: '10px 0' }}>
            Nuestro Equipo de <span style={{ color: '#3A6EA5' }}>Expertos</span>
          </h2>
          
          <div style={{ position: 'relative', width: '100px', height: '4px', background: '#3A6EA5', borderRadius: '2px' }}>
            <motion.div 
              animate={{ x: [0, 200, 0] }}
              transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
              style={{ position: 'absolute', width: '20px', height: '100%', background: '#8AB3CF', filter: 'blur(2px)' }}
            />
          </div>
          
          <p style={{ marginTop: '20px', color: '#666', fontSize: '1.1rem', maxWidth: '600px', lineHeight: '1.6' }}>
            Profesionales apasionados por la tecnología, comprometidos con la excelencia y la innovación.
          </p>
        </motion.div>
      </div>
      <Swiper
        key={isReady ? 'active' : 'waiting'}
        modules={[Autoplay, EffectCoverflow]}
        effect={'coverflow'}
        centeredSlides={true}
        slidesPerView={'auto'}
        loop={true}
        speed={1500}
        autoplay={isReady ? {
          delay: 2000,
          disableOnInteraction: false,
        } : false}
        coverflowEffect={{
          rotate: 0,
          stretch: 80,
          depth: 150,
          modifier: 1,
          slideShadows: false,
        }}
        className="my-swiper"
      >
        {staff.map((member, index) => (
          <SwiperSlide key={member.id} style={{ width: '650px', display: 'flex', justifyContent: 'center' }}>
            <motion.div 
              className={`carnet-horizontal ${index === 0 ? 'presidency-style' : ''}`}
              initial={index === 0 ? { scale: 0.8, opacity: 0 } : { x: 500, opacity: 0 }}
              animate={index === 0 ? { scale: 1, opacity: 1 } : (isReady ? { x: 0, opacity: 1 } : {})}
              transition={{ type: "spring", stiffness: 40, damping: 15 }}
              style={{
                width: '600px',
                height: '300px',
                background: '#fff',
                borderRadius: '20px',
                display: 'flex',
                flexDirection: 'row',
                boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
                border: index === 0 ? '2px solid #3A6EA5' : '1px solid #eee',
                overflow: 'hidden'
              }}
            >
              <div style={{ width: '40%', background: '#f8f9fa', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', borderRight: '2px dashed #eee' }}>
                <img src={member.img} alt="" style={{ width: '160px', height: '160px', borderRadius: '15px', objectFit: 'cover', border: '4px solid #fff' }} />
                <span style={{ marginTop: '15px', fontSize: '11px', color: '#aaa', fontWeight: 'bold' }}>STAFF ID: 00{member.id}</span>
              </div>

              <div style={{ width: '60%', padding: '30px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', textAlign: 'left' }}>
                <div>
                  <span style={{ color: '#3A6EA5', fontWeight: '900', fontSize: '12px', letterSpacing: '2px' }}>NAVESOLUTIONS</span>
                  <h3 style={{ fontSize: '2rem', margin: '15px 0 5px', color: '#1a1a1a' }}>{member.name}</h3>
                  <p style={{ color: '#666', fontWeight: '600', textTransform: 'uppercase', fontSize: '0.9rem' }}>{member.role}</p>
                  <span style={{ background: '#f0f0f0', padding: '5px 12px', borderRadius: '5px', fontSize: '0.8rem', color: '#444' }}>{member.area}</span>
                </div>
                
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div style={{ height: '30px', width: '120px', backgroundImage: 'repeating-linear-gradient(90deg, #333 0 1px, transparent 1px 4px)', opacity: 0.3 }}></div>
                  <div style={{ width: '40px', height: '30px', background: 'linear-gradient(135deg, #3A6EA5, #8AB3CF)', borderRadius: '5px' }}></div>
                </div>
              </div>
            </motion.div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

// ===================== SECCIÓN DE SERVICIOS =====================
const ServicesSection = () => {
  const services = [
    {
      icon: '◈',
      title: 'Diseño Web',
      description: 'Sitios web responsivos, optimizados para SEO y con experiencia de usuario excepcional.',
      features: ['E-commerce', 'Landing Pages', 'CMS Personalizado']
    },
    {
      icon: '⬢',
      title: 'Apps Móviles',
      description: 'Desarrollo nativo y multiplataforma para iOS y Android con las últimas tecnologías.',
      features: ['React Native', 'Flutter', 'Swift/Kotlin']
    },
    {
      icon: '⚙',
      title: 'Sistemas Web',
      description: 'Plataformas empresariales escalables, seguras y de alto rendimiento.',
      features: ['Dashboards', 'ERP', 'CRM']
    },
    {
      icon: '♾',
      title: 'SaaS',
      description: 'Desarrollo de software como servicio con arquitectura cloud y suscripciones.',
      features: ['Multi-tenant', 'API REST', 'Facturación']
    }
  ];

  return (
    <section className="corp-services-section">
      <div className="bg-tech-lines">
        {[1, 2, 3].map((_, i) => (
          <motion.div 
            key={i}
            className="tech-line"
            animate={{ 
              x: [-500, 1500],
              opacity: [0, 0.2, 0]
            }}
            transition={{ 
              duration: 10 + (i * 5), 
              repeat: Infinity, 
              ease: "linear",
              delay: i * 2 
            }}
          />
        ))}
      </div>

      <div className="container-services">
        <motion.div 
          className="services-header"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <span className="subtitle-green" style={{ color: '#3A6EA5' }}>| SERVICIOS TECNOLÓGICOS</span>
          <h2 className="title-dark">Lo que hacemos</h2>
        </motion.div>

        <div className="services-grid-modern">
          {services.map((service, index) => (
            <motion.div
              key={index}
              className="service-card-modern"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.15 }}
              whileHover={{ y: -10 }}
            >
              <motion.div 
                className="corp-icon-box"
                animate={{ rotateY: 360 }}
                transition={{ duration: 6, repeat: Infinity, ease: "linear" }}
                style={{ color: '#3A6EA5' }}
              >
                {service.icon}
              </motion.div>

              <h3 className="service-card-title">{service.title}</h3>
              <p className="service-card-desc">{service.description}</p>
              
              <div className="features-list-corp">
                {service.features.map((f, i) => (
                  <span key={i} className="feature-item-corp">
                    <span className="dot-green" style={{ backgroundColor: '#3A6EA5' }}></span> {f}
                  </span>
                ))}
              </div>

              <motion.button 
                className="btn-service-more"
                whileHover={{ gap: '15px' }}
                style={{ color: '#3A6EA5' }}
              >
                SABER MÁS <span>⟶</span>
              </motion.button>
              
              <div className="card-border-bottom" style={{ backgroundColor: '#3A6EA5' }}></div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

// ===================== NUEVA SECCIÓN: APPS DESCARGABLES =====================
const DownloadableApps = () => {
  const apps = [
    { name: "TechCRM", description: "Gestión de clientes y ventas", icon: "📱", downloadLink: "#", platform: "iOS/Android" },
    { name: "InventoryPro", description: "Control de inventario y almacenes", icon: "📦", downloadLink: "#", platform: "iOS/Android" },
    { name: "RestoManager", description: "Sistema para restaurantes", icon: "🍽️", downloadLink: "#", platform: "iOS/Android" },
    { name: "LogiTrack", description: "Seguimiento de envíos y rutas", icon: "🚚", downloadLink: "#", platform: "iOS/Android" },
  ];

  return (
    <section style={{ padding: '80px 20px', backgroundColor: '#F5F5F5' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          style={{ textAlign: 'center', marginBottom: '50px' }}
        >
          <span style={{ color: '#3A6EA5', fontWeight: 'bold', letterSpacing: '2px' }}>DESCARGAS</span>
          <h2 style={{ fontSize: '2.5rem', color: '#1A1A1A' }}>Nuestras Apps</h2>
          <p style={{ color: '#666' }}>Soluciones móviles para tu negocio, disponibles en las principales tiendas</p>
        </motion.div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '30px' }}>
          {apps.map((app, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              whileHover={{ y: -5 }}
              style={{ backgroundColor: 'white', borderRadius: '15px', padding: '25px', textAlign: 'center', boxShadow: '0 5px 20px rgba(0,0,0,0.05)' }}
            >
              <div style={{ fontSize: '3rem', marginBottom: '15px' }}>{app.icon}</div>
              <h3 style={{ fontSize: '1.5rem', marginBottom: '10px' }}>{app.name}</h3>
              <p style={{ color: '#666', marginBottom: '20px' }}>{app.description}</p>
              <span style={{ display: 'block', fontSize: '0.8rem', color: '#3A6EA5', marginBottom: '20px' }}>{app.platform}</span>
              <motion.a
                href={app.downloadLink}
                whileHover={{ scale: 1.05 }}
                style={{ display: 'inline-block', backgroundColor: '#2D2D2D', color: 'white', padding: '10px 25px', borderRadius: '30px', textDecoration: 'none' }}
              >
                Descargar
              </motion.a>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

// ===================== NUEVA SECCIÓN: DEMOS LIVE PREVIEW =====================
const LiveDemos = () => {
  const demos = [
    { name: "Dashboard Admin", description: "Panel de control administrativo", tech: "React + Node.js", link: "#", image: "/assets/Images/demo-dashboard.jpg" },
    { name: "E-commerce", description: "Tienda online completa", tech: "Next.js + Stripe", link: "#", image: "/assets/Images/demo-ecommerce.jpg" },
    { name: "SaaS Platform", description: "Plataforma de suscripciones", tech: "Vue + Laravel", link: "#", image: "/assets/Images/demo-saas.jpg" },
    { name: "Restaurant POS", description: "Sistema de punto de venta", tech: "React Native", link: "#", image: "/assets/Images/demo-pos.jpg" },
  ];

  return (
    <section style={{ padding: '80px 20px', backgroundColor: 'white' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          style={{ textAlign: 'center', marginBottom: '50px' }}
        >
          <span style={{ color: '#3A6EA5', fontWeight: 'bold', letterSpacing: '2px' }}>DEMOS EN VIVO</span>
          <h2 style={{ fontSize: '2.5rem', color: '#1A1A1A' }}>Prueba Nuestras Soluciones</h2>
          <p style={{ color: '#666' }}>Explora demos interactivas de nuestros productos antes de contratar</p>
        </motion.div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '30px' }}>
          {demos.map((demo, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ delay: index * 0.1 }}
              whileHover={{ y: -5 }}
              style={{ backgroundColor: '#F5F5F5', borderRadius: '15px', overflow: 'hidden', boxShadow: '0 5px 20px rgba(0,0,0,0.05)' }}
            >
              <div style={{ height: '200px', backgroundColor: '#DDD', backgroundImage: `url(${demo.image})`, backgroundSize: 'cover', backgroundPosition: 'center' }}></div>
              <div style={{ padding: '20px' }}>
                <h3 style={{ fontSize: '1.3rem', marginBottom: '10px' }}>{demo.name}</h3>
                <p style={{ color: '#666', marginBottom: '10px' }}>{demo.description}</p>
                <p style={{ fontSize: '0.8rem', color: '#3A6EA5', marginBottom: '20px' }}>{demo.tech}</p>
                <motion.a
                  href={demo.link}
                  whileHover={{ scale: 1.05 }}
                  style={{ display: 'inline-block', backgroundColor: '#2D2D2D', color: 'white', padding: '8px 20px', borderRadius: '30px', textDecoration: 'none' }}
                  target="_blank"
                >
                  Live Preview →
                </motion.a>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

// ===================== NUEVA SECCIÓN: VIDEOS SHORT YOUTUBE =====================
const VideoShorts = () => {
  const shorts = [
    { id: "o-r4EI9J_Qc", title: "Comunicación satelital - 3D Render" },
    { id: "nVhbix8G-4o", title: "Demo de app móvil" },
    { id: "k3TDPpcWveQ", title: "Tutorial: Dashboard Admin" },
    { id: "dmrl09mX9_A", title: "Nueva funcionalidad SaaS" },
  ];

  return (
    <section style={{ padding: '80px 20px', backgroundColor: '#F5F5F5' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          style={{ textAlign: 'center', marginBottom: '50px' }}
        >
          <span style={{ color: '#3A6EA5', fontWeight: 'bold', letterSpacing: '2px' }}>VIDEOS RÁPIDOS</span>
          <h2 style={{ fontSize: '2.5rem', color: '#1A1A1A' }}>Conoce Nuestro Trabajo</h2>
          <p style={{ color: '#666' }}>Shorts de YouTube con demostraciones y tutoriales</p>
        </motion.div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '30px' }}>
          {shorts.map((short, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              style={{ backgroundColor: 'white', borderRadius: '15px', overflow: 'hidden', boxShadow: '0 5px 20px rgba(0,0,0,0.05)' }}
            >
              <div style={{ position: 'relative', paddingBottom: '177.77%' }}>
                <iframe
                  style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                  src={`https://www.youtube.com/embed/${short.id}?autoplay=1&mute=1&loop=1&playlist=${short.id}&controls=0&modestbranding=1&rel=0`}
                  title={short.title}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen
                ></iframe>
              </div>
              <div style={{ padding: '15px' }}>
                <h3 style={{ fontSize: '1rem', margin: 0 }}>{short.title}</h3>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

// ===================== FOOTER =====================
const Footer = () => {
  return (
    <footer className="footer-slaze">
      <div className="cta-floating-container">
        <div className="cta-green-box" style={{ backgroundColor: '#2D2D2D' }}>
          <div className="cta-content">
            <h2 className="cta-title">¿Listo para transformar tu negocio?<br />Hablemos de tu proyecto</h2>
            <div className="cta-actions">
              <button className="btn-start" style={{ backgroundColor: '#3A6EA5' }}>COTIZAR PROYECTO</button>
              <div className="cta-help">
                <div className="phone-icon-circle" style={{ backgroundColor: '#3A6EA5' }}>📞</div>
                <div className="help-text">
                  <span>¿Necesitas ayuda?</span>
                  <strong> +52 55 1234 5678</strong>
                </div>
              </div>
            </div>
          </div>
          <div className="cta-image-worker">
            <img src="/assets/Images/tech-worker.png" alt="Tech professional" />
          </div>
        </div>
      </div>

      <div className="footer-main-dark" style={{ backgroundColor: '#1A1A1A' }}>
        <div className="footer-container">
          <div className="footer-grid">
            <div className="footer-col about">
              <div className="footer-logo">
                <div className="logo-content">
                  <img 
                    src="/assets/Images/logotech.png" 
                    alt="Tech Solutions" 
                    className="logo-image"
                    style={{ 
                      height: '70px', 
                      width: 'auto',
                      display: 'block'
                    }}
                  />
                </div>
              </div>
              <p className="footer-address">
                Av. Tecnológico 123, Piso 5<br />
                Center, Miami<br />
                CP 06000, USA
              </p>
              <div className="footer-socials"></div>
            </div>

            <div className="footer-col contact-info">
              <div className="contact-item">
                <h4 className="footer-h4">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
                  Teléfonos
                </h4>
                <div className="contact-links">
                  <a href="tel:+525512345678" className="footer-p-link">+1 (305) 833-0054</a>
                  <a href="tel:+525512345679" className="footer-p-link">+1 (305) 833-0054</a>
                </div>
                <h4 className="footer-h4 email-h4">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
                  Email
                </h4>
                <div className="contact-links">
                  <a href="mailto:info@techsolutions.com" className="footer-p-link">info@navesolution.com</a>
                </div>
              </div>
            </div>

            <div className="footer-col links">
              <h4 className="footer-h4">Recursos</h4>
              <ul>
                <li><a href="#">Sobre Nosotros</a></li>
                <li><a href="#">Blog</a></li>
                <li><a href="#">Testimonios</a></li>
                <li><a href="#">Preguntas Frecuentes</a></li>
                <li><a href="#">Contáctanos</a></li>
              </ul>
            </div>

            <div className="footer-col subscribe">
              <h4 className="footer-h4">Suscríbete</h4>
              <div className="sub-input-group">
                <input type="email" placeholder="Correo Electrónico" />
                <button className="btn-sub" style={{ backgroundColor: '#3A6EA5' }}>➤</button>
              </div>
              <label className="terms-label">
                <input type="checkbox" /> Acepto los términos y condiciones
              </label>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-container bottom-flex">
            <p>Copyright 2026 - Todos los derechos reservados por <span className="green-txt" style={{ color: '#3A6EA5' }}>NaveSolution</span></p>
            <div className="bottom-links">
              <a href="#">Política de Privacidad</a>
              <a href="#">Términos y Condiciones</a>
            </div>
          </div>
        </div>
      </div>

      <button className="scroll-top-btn">↑</button>
    </footer>
  );
};

// ===================== PÁGINAS =====================
const Inicio = () => (
  <motion.div
    className="page"
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    exit={{ opacity: 0 }}
  >
    <Hero />
    <AboutSection />
    <ProjectGallery />
    <StatsSection />
    <TeamCarousel />
    <ServicesSection />
    <DownloadableApps />
    <LiveDemos />
    <VideoShorts />
  </motion.div>
);

const Servicios = () => (
  <motion.div
    className="page"
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    exit={{ opacity: 0 }}
  >
    <div className="page-content">
      <h1>Servicios</h1>
    </div>
  </motion.div>
);

const Productos = () => (
  <motion.div
    className="page"
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    exit={{ opacity: 0 }}
  >
    <div className="page-content">
      <h1>Productos</h1>
    </div>
  </motion.div>
);

const Demo = () => (
  <motion.div
    className="page"
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    exit={{ opacity: 0 }}
  >
    <div className="page-content">
      <h1>Demos</h1>
    </div>
  </motion.div>
);

const Contacto = () => (
  <motion.div
    className="page"
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    exit={{ opacity: 0 }}
  >
    <div className="page-content">
      <h1>Contacto</h1>
    </div>
  </motion.div>
);

// ===================== APP PRINCIPAL =====================
const App = () => {
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState('inicio');
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const renderPage = () => {
    switch(currentPage) {
      case 'inicio':
        return <Inicio />;
      case 'servicios':
        return <Servicios />;
      case 'productos':
        return <Productos />;
      case 'demo':
        return <Demo />;
      case 'contacto':
        return <Contacto />;
      default:
        return <Inicio />;
    }
  };

  if (loading) {
    return <LoadingScreen onComplete={() => setLoading(false)} />;
  }

  return (
    <div className="app">
      <Navbar 
        scrolled={scrolled} 
        setCurrentPage={setCurrentPage}
        currentPage={currentPage}
      />
      <AnimatePresence mode="wait">
        {renderPage()}
      </AnimatePresence>
      <Footer />
    </div>
  );
};

export default App;